import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/** Reducers **/
import { NotificationFacade } from "@redux/facades/notification.facade";
/** Modules */
import { LandingLayoutRoutes } from './landing-layout.routing';
/** COMPONENTS */
import { ComponentsModule } from '@components/components.module';
/** PIPES */
import { PipesModule } from '@pipes/pipes.module';
/** EXTERNAL */
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormComponent } from "@modules/landing/pages/form/form.component";
import { SearchComponent } from "@modules/landing/pages/search/search.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(LandingLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    /** Pipes */
    PipesModule,
    /** Components */
    ComponentsModule
  ],
  declarations: [
    /** Pages */
    FormComponent,
    SearchComponent,
    /** Components */
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-US' }
  ],
  exports: []
})

export class LandingLayoutModule {}
